import { createContext, useRef, useState } from "react";
import reqCliente from "../../../../services/reqMultiTenant/reqCliente";

const ContextRegisterClient = createContext({});

function RegisterClientProvider(props) {
	// Controle Modal
	const [isOpenModalFilterClient, setIsOpenModalFilterClient] = useState(false);
	const [isOpenModalRegisterClient, setIsOpenModalRegisterClient] = useState(false);

	//Dados do cliente
	const [id_cliente, setIdCliente] = useState(0);
	const [clientsData, setClientsData] = useState([]);
	const [filterData, setFilterData] = useState({});

	//Controle de paginação
	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(0);
	const currentPage = useRef(0);

	const [loading, setLoading] = useState(false);

	const openModalFilterClient = () => {
		setIsOpenModalFilterClient((prevState) => !prevState);
	};

	const openModalRegisterClient = (item) => {
		let id = 0;

		if (item?.id_cliente) id = item.id_cliente;

		setIdCliente(id);

		setIsOpenModalRegisterClient(true);
	};

	const closeModalRegisterClient = () => {
		setIsOpenModalRegisterClient(false);
	};

	// busca o resultado completo da pesquisa (mesmos filtros), sem paginação, usado para gerar o relatório
	const fetchAllClients = async () => {
		const { param, paramValue, ativo } = filterData;

		const response = await reqCliente.listPaginate(param, paramValue, ativo, 1, 100000);
		return response?.data || [];
	};

	const fetchClientsPage = async () => {
		setLoading(true);
		try {
			try {
				const { param, paramValue, active } = filterData;

				let ativo = "NAO";
				if (active === true) ativo = "SIM";

				const responseClient = await reqCliente.listPaginate(param, paramValue, ativo, currentPage.current + 1);

				setClientsData((prevData) => [...prevData, ...responseClient.data]);

				//se não encontrou nada esta na ultima pagina
				if (responseClient.data.length < 15) {
					setTotalPage(currentPage.current + 1);
				}

				if (responseClient.data.length !== 0) currentPage.current++;
			} catch (error) {
				setClientsData([]);
				// Notification.showToast({ message: error.message, type: "warning" });
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<ContextRegisterClient.Provider
			value={{
				isOpenModalFilterClient,
				isOpenModalRegisterClient,
				id_cliente,
				openModalRegisterClient,
				closeModalRegisterClient,
				openModalFilterClient,
				setClientsData,
				setFilterData,
				filterData,
				clientsData,
				currentPage,
				fetchClientsPage,
				fetchAllClients,
				page,
				setPage,
				totalPage,
				setTotalPage,
				loading,
				setLoading,
			}}
		>
			{props.children}
		</ContextRegisterClient.Provider>
	);
}

export { ContextRegisterClient, RegisterClientProvider };
